import { combustibleClearance } from './combustible-clearance';
import { countertopSeamLimit } from './countertop-seams/countertop-seam-limit';
import { countertopDepthLimit } from './island-size-limits/countertop-depth-limit'
import { islandDepthItemLimit } from './island-size-limits/island-depth-item-limit';
import { islandHeightLimit } from './island-size-limits/island-height-limit'
import { overhangLimit } from './overhang-limit/overhang-limit';
import { panelEdgeLimit } from './spacing-limits/panel-edge-limit'

import { RuleScope } from '../constants';

export const validationsMap = {
	// requiresVenting is a category rule
	overhangLimit: {
		func: overhangLimit,
		scope: RuleScope.Island
	},
	islandHeightLimit: {
		func: islandHeightLimit,
		scope: RuleScope.Island
	},
	islandDepthItemLimit: {
		func: islandDepthItemLimit,
		scope: RuleScope.Island
	},
	countertopDepthLimit: {
		func: countertopDepthLimit,
		scope: RuleScope.Island
	},
	panelEdgeLimit: {
		func: panelEdgeLimit,
		scope: RuleScope.PanelItemGroup
	},
	combustibleClearance: {
		func: combustibleClearance,
		scope: RuleScope.Island
	},
	countertopSeamLimit: {
		func: countertopSeamLimit,
		scope: RuleScope.Island
	}
};
